import * as React from 'react';
import i18n, { getDateFormatOptions } from '@/utils/i18n';
import './StatusHistoryTimeline.css';

export interface StatusHistoryTimelineProps {
  statusHistory: Record<string, string>;
  className?: string;
}

export const StatusHistoryTimeline: React.FC<StatusHistoryTimelineProps> = ({
  statusHistory,
  className = '',
}) => {
  return (
    <div className={`status-history-timeline ${className}`}>
      {[...Object.entries(statusHistory)]
        .sort((a, b) => b[1].localeCompare(a[1]))
        .map(([status, date], index, array) => (
          <div key={status} className="status-timeline-item">
            <div className="status-timeline-marker">
              {index > 0 && <div className="status-timeline-line"></div>}
              <div className="status-timeline-dot"></div>
              {array.length > 1 && index === array.length - 1 && (
                <div className="status-timeline-line"></div>
              )}
            </div>
            <div className="status-timeline-content">
              <div className="status-timeline-status">{status}</div>
              <div className="status-timeline-date">
                {new Date(date).toLocaleDateString(
                  i18n.language,
                  getDateFormatOptions(true),
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default StatusHistoryTimeline;
